export const BrandingConstants = {
  api_url_name: 'API_URL',
}